'use strict'

module.exports = '/mplex/6.7.0'



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-multiplex/src/multiplex-codec.js
// module id = 256
// module chunks = 0